"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformServices = void 0;
const transformServices = (partnerServices, partnerAdditionalServices, partnerServiceLabels) => {
    const relevantServices = [...partnerServiceLabels.keys()];
    let services = [
        ...partnerServices
            .filter((value) => relevantServices.includes(value))
            .map((service) => partnerServiceLabels.get(service)),
    ].join(", ");
    if ((partnerAdditionalServices === null || partnerAdditionalServices === void 0 ? void 0 : partnerAdditionalServices.length) > 0) {
        const additionalServices = [...partnerAdditionalServices].join(", ");
        services = [services, additionalServices].join(", ");
    }
    services = services.replace(/,\s*$/, "");
    return services;
};
exports.transformServices = transformServices;
//# sourceMappingURL=partner-service-string.js.map